import {library} from '@fortawesome/fontawesome-svg-core';
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'

import {faInstagram, faFacebook, faFacebookF} from '@fortawesome/free-brands-svg-icons'

import {
    faSignIn, faEye, faEyeSlash, faGlobeAmericas, faUser, faCog, faTachometerAltFast, faWallet, faCashRegister,
    faChartPie, faAppleAlt, faAngleDown, faSearch, faTag, faUserTie, faAt, faPhone, faQuoteRight, faHashtag,
    faBirthdayCake, faChevronDoubleRight, faBars, faTimes, faSyncAlt, faSpinner, faFolderOpen, faExclamationTriangle,
    faUndo, faRedo, faFileContract, faPrint, faCut, faTable, faHourglassStart, faMotorcycle, faHandHoldingBox,
    faDollarSign, faLanguage, faClock, faLayerGroup, faHourglassEnd, faPlus, faNetworkWired
} from '@fortawesome/pro-light-svg-icons'

library.add(
    faSignIn, faEye, faEyeSlash, faGlobeAmericas,
    faInstagram, faFacebook, faFacebookF, faUser, faCog, faTachometerAltFast, faWallet, faCashRegister, faChartPie, faAppleAlt,
    faAngleDown, faSearch, faTag, faUserTie, faAt, faPhone, faQuoteRight, faHashtag, faBirthdayCake,
    faChevronDoubleRight, faBars, faTimes, faSyncAlt, faSpinner, faFolderOpen, faExclamationTriangle, faUndo, faRedo,
    faFileContract, faPrint, faCut, faTable, faHourglassStart, faMotorcycle, faHandHoldingBox, faDollarSign, faLanguage,
    faClock, faLayerGroup, faHourglassEnd, faPlus, faNetworkWired
);

export function inject(Vue) {
    Vue.component('font-awesome-icon', FontAwesomeIcon);
}
